
const ourServicesList = [
  {
    title: 'Understand the market',
    shortDescription: 'Get a holistic view of the healthcare and pharma market through our insightful ',
    link: '/consulting/market-assessment-services',
    imageSrc: 'img/home/png/understand-the-market.png',
    altText: 'Get a holistic view of the healthcare and pharma market through our insightful ',
    buttonTitle: 'Know More',
  },
  {
    title: 'Estimate the forecast',
    shortDescription: 'Be the leader in the pharma market with the help of our 10-year market and epidemiology forecast',
    link: '/report-store.php?category=Market Insight',
    imageSrc: 'img/home/png/estimate-the-forecast.png',
    altText: 'Be the leader in the pharma market with the help of our 10-year market and epidemiology forecast',
    buttonTitle: 'Know More',
  },
  {
    title: 'Analyze the pipeline',
    shortDescription: 'Gain rich knowledge of the upcoming therapies for better business-related decisions',
    link: '/report-store.php?category=Pipeline Insight',
    imageSrc: 'img/home/png/analyse-the-pipeline.png',
    altText: 'Gain rich knowledge of the upcoming therapies for better business-related decisions',
    buttonTitle: 'Know More',
  },
  {
    title: 'Monitor the competitors',
    shortDescription: 'Know and inspect your competitors to stand out in the industry',
    link: '/consulting/competitive-intelligence-services',
    imageSrc: 'img/home/png/monitor-the-competitors.png',
    altText: 'Know and inspect your competitors to stand out in the industry',
    buttonTitle: 'Know More',
  },
  {
    title: 'Streamline your journey',
    shortDescription: 'Consulting services that help in meeting desired goals through optimized strategy',
    link: '/consulting/asset-prioritizaton-services',
    imageSrc: 'img/home/png/streamline-your-journey.png',
    altText: 'Consulting services that help in meeting desired goals through optimized strategy',
    buttonTitle: 'Know More',
  },
  {
    title: 'Accelerate your growth',
    shortDescription: 'Exploit innovative ideas through our in-depth and curated R&D services',
    link: '/consulting/business-development-services',
    imageSrc: 'img/home/png/accelerate-your-growth.png',
    altText: 'Exploit innovative ideas through our in-depth and curated R&D services',
    buttonTitle: 'Know More',
  }
];
const accordionList = [
  {
    title: 'Customizable Reports',
    content: 'Customized reports specific to geographies, clinical trials, epidemiological trends, and markets.',
    link: '/report-store.php',
    buttonTitle: 'Know More',
  },
  {
    title: 'Customizable Solutions',
    content: 'Identify your needs, and our analysts will provide granular-level market intelligence to fulfill them.',
    link: '/request-for-proposal',
    buttonTitle: 'Know More',
  },
  {
    title: 'Customizable Competitive Intelligence',
    content: 'Custom-based analysis of the competitors to meet your unique needs.',
    link: '/consulting/competitive-intelligence-services',
    buttonTitle: 'Know More',
  },
  {
    title: 'Customizable Packages',
    content: 'Hassle-free subscription-based report packages the way you desire through our PharmDelve.',
    link: '/pharmdelve',
    buttonTitle: 'Know More',
  },
];
const counterList = [
  {
    title: 'Reports',
    imageSrc: 'img/home/svg/research_reports.svg',
    altText: 'Reports',
    numbers: '7000',
  },
  {
    title: 'Consulting Projects',
    imageSrc: 'img/home/svg/consulting_projects.svg',
    altText: 'Consulting Projects',
    numbers: '500',
  },
  {
    title: 'Satisfied Clients',
    imageSrc: 'img/home/svg/satisfied_clients.svg',
    altText: 'Satisfied Clients',
    numbers: '1000',
  },
  {
    title: 'Customized Reports',
    imageSrc: 'img/home/svg/customized_reports.svg',
    altText: 'Customized Reports',
    numbers: '1200',
  },
];
const blogList = [
  {
    title: <>Novo Nordisk vs. Eli Lilly: The Battle for Anti-Obesity Drug Market Dominance</>,
    shortDescription: <>The global obesity crisis has sparked a multibillion-dollar showdown in the pharmaceutical world, with Novo Nordisk and Eli Lilly locked in an intense battle for supremacy. These industry titans are redefining the weight loss drug market with groundbreaking GLP-1 therapies. Novo Nordisk&apos;s WEGOVY (semaglutide) and Eli Lilly&apos;s ZEPBOUND (tirzepatide) are reshaping the anti-obesity drug market—but which powerhouse will claim the top spot in this high-stakes race?</>,
    link: "/blog/novo-vs-eli-lilly-in-anti-obesity-drug-market",
    imageSrc: "img/home/png/novo-vs-eli-lilly-in-anti-obesity-drug-market.png",
    altText: <>Novo Nordisk vs. Eli Lilly: The Battle for Anti-Obesity Drug Market Dominance</>,
  },
  {
    title: <>7 Emerging Spinal Muscular Atrophy Therapies Offering Hope for Patients</>,
    shortDescription: <>The approval of three spinal muscular atrophy therapies—SPINRAZA (Ionis/Biogen), EVRYSDI (Roche), and the groundbreaking gene therapy ZOLGENSMA (Novartis) has significantly advanced treatment options for a condition that previously had limited solutions. These spinal muscular atrophy (SMA) therapies offer patients more personalized care.</>,
    link: "/blog/spinal-muscular-atrophy-therapies-in-development",
    imageSrc: "img/home/png/spinal-muscular-atrophy-therapies-in-development.png",
    altText: <>7 Emerging Spinal Muscular Atrophy Therapies Offering Hope for Patients</>,
  },
  {
    title: <>J&J Enters gMG Arena with IMAAVY Approval, Challenging AstraZeneca, Argenx, and UCB</>,
    shortDescription: <>The FDA has approved Johnson & Johnson&apos;s anti-FcRn antibody, nipocalimab, for the treatment of generalized myasthenia gravis (gMG). This myasthenia gravis drug will be marketed under the name IMAAVY. Although J&J isn&apos;t the first to receive FDA approval for an FcRn-blocking antibody in this indication, the company is optimistic that IMAAVY&apos;s broad label will help secure a strong foothold in the FcRN inhibitors market over time.</>,
    link: "/blog/imaavy-for-generalized-myasthenia-gravis",
    imageSrc: "img/home/png/imaavy-for-generalized-myasthenia-gravis.png",
    altText: <>J&J Enters gMG Arena with IMAAVY Approval, Challenging AstraZeneca, Argenx, and UCB</>,
  },
  {
    title: <>9 Promising Obesity Drugs Set to Launch by 2030</>,
    shortDescription: <>The pharmaceutical industry is witnessing a seismic shift, fueled by the meteoric rise of GLP-1 agonist molecules. Once a niche class of diabetes drugs, GLP-1 agonists have become the cornerstone of a global race to conquer obesity, a disease that has more than doubled in prevalence since 1990 and now affects over 42% of U.S. adults and nearly a billion people worldwide. The promise? A shot at transforming pharma giants into trillion-dollar titans and rewriting the future of healthcare.</>,
    link: "/blog/obesity-drugs-launch",
    imageSrc: "img/home/png/obesity-drugs-launch.png",
    altText: <>9 Promising Obesity Drugs Set to Launch by 2030</>,
  },
  {
    title: <>Prader-Willi Syndrome Drug Market Heats Up: 5 Upcoming Challengers to Soleno&apos;s VYKAT XR</>,
    shortDescription: <>Since the FDA approved recombinant human growth hormone (rhGH) for Prader-Willi syndrome in 2000, numerous companies have faced challenges in developing more advanced treatments for hyperphagia, the uncontrollable hunger associated with PWS.</>,
    link: "/blog/prader-willi-syndrome-drugs",
    imageSrc: "img/home/png/prader-willi-syndrome-drugs.png",
    altText: <>Prader-Willi Syndrome Drug Market Heats Up: 5 Upcoming Challengers to Soleno&aposs VYKAT XR</>,
  },
  {
    title: <>Sanofi&apos;s Qfitlia Enters the Hemophilia Market—What Sets It Apart?</>,
    shortDescription: <>Over the past three years, the FDA has approved six new hemophilia treatments, including three gene therapies. Now, Sanofi&apos;s Qfitlia (fitusiran) enters the competitive hemophilia therapeutics market, distinguishing itself as the only therapy approved for all types of hemophilia. Unlike most existing treatments, Qfitlia is indicated for routine prophylaxis to prevent or reduce bleeding episodes in adults and pediatric patients (12 years and older) for both hemophilia A and B and is effective regardless of inhibitor status—a key advantage for patients who develop factor VIII or factor IX inhibitors, which can reduce the effectiveness of standard clotting factor replacement therapies.</>,
    link: "/blog/qfitlia-for-hemophilia-treatment",
    imageSrc: "img/home/png/qfitlia-for-hemophilia-treatment.png",
    altText: <>Sanofi&apos;s Qfitlia Enters the Hemophilia Market—What Sets It Apart?</>,
  },
];
const reportList = {
  content: [
    {
      title: 'Latest Reports',
      description: 'Get comprehensive insights into the healthcare industry and epidemiology-based market forecasts with a 360° panoramic picture of the market alongside the latest trends, developments, and future opportunities.',
      shortTitle: 'Report Store',
      shortDescription: 'With over 7000 research reports in the repository covering 27 therapeutic areas, stay updated about the most recent trends, news, and developments in the healthcare domain.',
      buttonTitle: 'Explore Now',
    },
  ],
  items: [
    {
      link: '/report-store/epilepsy-market',
      imageSrc: 'products/report-image/epilepsy-market-reports.png',
      altText: 'Epilepsy Market Insight, Epidemiology and Market Forecast -2034',
    },
    {
      link: '/report-store/intratumoral-cancer-therapies-market',
      imageSrc: 'products/report-image/intratumoral-cancer-therapies-market-report.png',
      altText: 'Intra-tumoral Cancer Therapies – Market Insights, Epidemiology, and Market Forecast – 2034',
    },
    {
      link: '/report-store/iga-nephropathy-igan-market',
      imageSrc: 'products/report-image/iga-nephropathy-igan-market.png',
      altText: 'IgA Nephropathy (IgAN) - Market Insight, Epidemiology And Market Forecast - 2034',
    },
    {
      link: '/report-store/her2-low-cancers-market-forecast',
      imageSrc: 'products/report-image/her2-low-cancers-market.png',
      altText: 'HER2-low Cancers – Market Size, Target Population, Competitive Landscape, and Market Forecast–2034',
    },
    {
      link: '/report-store/peanut-allergy-market',
      imageSrc: 'products/report-image/peanut-allergy-market.png',
      altText: 'Peanut Allergy Market Insight, Epidemiology And Market Forecast - 2034',
    },
  ],
};
export {
  ourServicesList,
  accordionList,
  counterList,
  blogList,
  reportList,
}